import {
  IonIcon,
  IonItem,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { tvOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./WECharacTour.css";

function WECharacTour() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-up">
        <IonIcon icon={tvOutline} slot="start" className="ion-icon"></IonIcon>

        <IonModal
          isOpen={showModal}
          className="ion-modal-popup"
          backdropDismiss="false"
        >
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>Data Scientist @ CharacTour</b>
            <br />
            <p>
              {" "}
              From October 2019 to March 2020, I was a data scientist at a{" "}
              <a
                href="https://start.charactour.com/about/"
                target="_blank"
                rel="noreferrer"
              >
                Series A entertainment startup
              </a>
              . In the projects section, I demoed a couple multi-dimensional data
              analysis projects that I completed throughout my time there.{" "}
            </p>
            <br />
          </IonText>

          <IonButton className="ion-button" onClick={() => setShowModal(false)}>
            Close
          </IonButton>
        </IonModal>

        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          Show
        </IonButton>
      </IonItem>
    </div>
  );
}

export default WECharacTour;
